import * as React from "react";
import { Button, ButtonProps, Dialog, DialogProps } from "@mui/material";

interface Props {
    btn: Omit<ButtonProps, "onClick">;
    dialog: Omit<DialogProps, "open" | "onClose">;
    state: DialogState;
}

export const DialogButton: React.FunctionComponent<Props> = (p) => {
    return (
        <>
            <Button
                {...p.btn}
                onClick={() => {
                    p.state.setOpen((current) => !current);
                }}
            />
            <Dialog
                {...p.dialog}
                open={p.state.isOpen}
                onClose={p.state.close}
            />
        </>
    );
};

export const useDialogState = (defaultOpen = false) => {
    const [isOpen, setOpen] = React.useState(defaultOpen);

    return {
        isOpen,
        setOpen,
        toggle: () => setOpen((open) => !open),
        close: () => setOpen(false), // used more often then open -> extracted
    };
};

export type DialogState = ReturnType<typeof useDialogState>;
